const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const UTM_MAX_AGE = 35 * 60;
const UTM_SUBDOMAIN = "account.orm-service.com";

const getUTMFromCookies = (): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const key of UTM_PARAMS) {
    const match = document.cookie.match(new RegExp("(?:^|; )" + key + "=([^;]*)"));
    if (match) result[key] = decodeURIComponent(match[1]);
  }
  return result;
};

const appendUTMToSubdomainLinks = () => {
  const utms = getUTMFromCookies();
  if (Object.keys(utms).length === 0) return;

  document.querySelectorAll<HTMLAnchorElement>(`a[href*="${UTM_SUBDOMAIN}"]`).forEach((link) => {
    const url = new URL(link.href);
    for (const [key, value] of Object.entries(utms)) {
      url.searchParams.set(key, value);
    }
    link.href = url.toString();
  });
};

export const initUTM = () => {
  const params = new URLSearchParams(window.location.search);
  const incoming: Record<string, string> = {};

  for (const key of UTM_PARAMS) {
    const value = params.get(key);
    if (value) incoming[key] = value;
  }

  if (Object.keys(incoming).length > 0) {
    for (const [key, value] of Object.entries(incoming)) {
      document.cookie = `${key}=${encodeURIComponent(value)}; path=/; max-age=${UTM_MAX_AGE}`;
    }
  }

  const stored = getUTMFromCookies();
  for (const key of UTM_PARAMS) {
    document.querySelectorAll<HTMLInputElement>(`input[name="${key}"]`).forEach((input) => {
      input.value = stored[key] ?? "not specified";
    });
  }

  appendUTMToSubdomainLinks();
};
